import { colorsPalettes } from "@similarweb/styles";
import { TabPanel } from "@similarweb/ui-components";
import { WidgetFooterContainer } from "app/components/React/WidgetContainer/styledComponents";
import { TrendContainer } from "app/components/React/Table/cells/TrendCell";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const TopCompetitorsWrapper = styled.div`
    width: 100%;
    .swReactTable-container {
        border-top: unset;
    }
    .swTable-headerCell {
        background-color: ${colorsPalettes.carbon[0]};
        border-right: unset;
        height: 40px;
    }
    .swTable-cell {
        &:last-child {
            border-bottom: unset;
        }
    }
    .website-column {
        .swTable-headerCell,
        .website-cell {
            padding-left: 24px;
        }
    }
    ${WidgetFooterContainer} {
        a:last-child {
            margin-left: calc(50% - 100px);
        }
    }
`;

export const ClicksTrendContainer = styled(FlexRow)`
    height: 100%;
    align-items: center;
    gap: 24px;
`;

export const TrendContainerStyled = styled(TrendContainer)`
    width: 200px;
`;

export const ClicksTrendValueContainer = styled.div`
    width: 48px;
`;

const TableContainer = styled.div`
    padding-bottom: 24px;
    &:last-child {
        padding-bottom: 0;
    }
`;

export const TableContainerWrapper = styled(TableContainer)`
    width: 50%;
    &:first-child {
        border-right: 1px solid ${colorsPalettes.carbon[100]};
    }
`;

const TabPanelWrapper = styled(TabPanel)`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
